/**
 * Prevent layout shift when assurance modals open (scrollbar compensation).
 */
(function () {
  function syncScrollbarPadding() {
    if (document.body.classList.contains('overflow-hidden')) {
      const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
      document.body.style.paddingRight = scrollbarWidth > 0 ? `${scrollbarWidth}px` : '';
    } else {
      document.body.style.paddingRight = '';
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  function init() {
    syncScrollbarPadding();

    const bodyObserver = new MutationObserver(syncScrollbarPadding);
    bodyObserver.observe(document.body, { attributes: true, attributeFilter: ['class'] });

    window.addEventListener('resize', syncScrollbarPadding);
    document.addEventListener('modalClosed', syncScrollbarPadding);
  }
})();
